/** Keep the leading tabs in source order, making room for the current section. */
export function fitTabs(widths: number[], available: number, moreWidth: number, gap = 0, active = -1): number[] {
	if (widths.reduce((total, width) => total + width, 0) + Math.max(0, widths.length - 1) * gap <= available) {
		return widths.map((_, index) => index);
	}
	let remaining = Math.max(0, available - moreWidth);
	const visible: number[] = [];
	for (let index = 0; index < widths.length; index++) {
		if (widths[index] + gap > remaining) break;
		visible.push(index);
		remaining -= widths[index] + gap;
	}
	if (active >= 0 && active < widths.length && !visible.includes(active)) {
		while (visible.length && widths[active] + gap > remaining) {
			remaining += widths[visible.pop()!] + gap;
		}
		// An oversized active tab stays visible; the row truncates its label.
		visible.push(active);
	}
	return visible;
}
